import { render } from "./RiBookmarkOn.vue?vue&type=template&id=276546c2"
import script from "./RiBookmarkOn.vue?vue&type=script&lang=js"
export * from "./RiBookmarkOn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiBookmarkOn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "276546c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('276546c2', __exports__)) {
    api.reload('276546c2', __exports__)
  }
  
  module.hot.accept("./RiBookmarkOn.vue?vue&type=template&id=276546c2", () => {
    api.rerender('276546c2', render)
  })

}


export default __exports__